/*
 * Gateway paths for the marketplace review seam.
 *
 * Split out for the same reason the awsCachePaths / gcpDiskPaths modules are: a
 * path is the one part of an API binding a test can pin without standing up
 * axios, and the
 * wire contract these mirror is frozen (bluebear-gateway
 * docs/marketplace-seams-2026-09-06.md, "The wire contract").
 *
 * The gateway's axios baseURL already carries /api/v1, so these are the tail.
 */
export const marketplaceReviewPaths = {
  /** GET — the review queue, tenant-scoped, filtered by ?status= */
  queue: () => '/marketplace/executions',
  /** POST — record a reviewer's correction to one FINDING (never code). */
  corrections: (executionId) =>
    `/marketplace/executions/${encodeURIComponent(executionId)}/corrections`,
  /** POST — attest and release. Assignee only; 403 NOT_REVIEW_ASSIGNEE otherwise. */
  release: (executionId) =>
    `/marketplace/executions/${encodeURIComponent(executionId)}/release`,
  /** POST — reject with an optional reason. Assignee only. Reverses the charge. */
  reject: (executionId) =>
    `/marketplace/executions/${encodeURIComponent(executionId)}/reject`,
  /** GET — every earning event where the caller is the payee. */
  earnings: () => '/publishers/me/earnings',
  /** GET — access requests for offers owned by the caller's publisher tenant. */
  accessRequests: () => '/publishers/me/access-requests',
  /** GET/POST — seller-owned drafts and listed offers. */
  publisherOffers: () => '/publishers/me/offers',
  /** PATCH — update one seller-owned draft. */
  publisherOffer: (slug) => `/publishers/me/offers/${encodeURIComponent(slug)}`,
  /** POST — freeze a draft and send it to BlueBear review. */
  submitPublisherOffer: (slug) =>
    `/publishers/me/offers/${encodeURIComponent(slug)}/submit`,
};

export default marketplaceReviewPaths;
